<script setup>
import { opportunities } from "@/services/constant-services";
import { useUserStore } from "@/store/user-store";

const store = useUserStore();

const handleOpportunityClick = (opportunity) => {
  if (opportunity.route) {
    // Navigate to the corresponding sidebar menu item
    store.setTabView(opportunity.route);
  } else {
    // Show a message for items without navigation
    store.fireAlert("Info", "This feature is coming soon!");
  }
};
</script>

<template>
  <div class="mt-30">
    <span class="font-20 font-weight-700">Explore Opportunities</span>
    <div class="grid-container d-grid gap-20 mt-20">
      <div
        v-for="(item, index) in opportunities"
        :key="index"
        class="grid-item cursor-pointer d-flex align-items-center justify-center p-15 br-10 text-center font-weight-500"
        @click="handleOpportunityClick(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.grid-container {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

.grid-item {
  background-color: var(--an-primary);
  color: var(--an-white);
}
</style>
